import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import userService from "../../services/user-service";
import Skeleton from 'react-loading-skeleton'
import { SearchOutlined } from "@ant-design/icons";
import { Card, Form, Pagination, Spin, Table, Button, Input, Divider } from "antd";
import { ToastContainer, toast } from 'react-toastify';

const AdminUsers = () => {
  let navigate = useNavigate();
  const [roleList, setRoleList] = useState([]);
  const [list, setList] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [showProfiles, setShowProfiles] = useState(true);




  ////TODO ESTO ES DE PAGINACION/////////

  const [usernameOld, setUsernameOld] = useState("");
  const [usernameSession, setUsernameSession] = useState("");
  const [findName, setFindName] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [total, setTotal] = useState(0);

  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };




  const optionsState = [
    { id: true, name: "ACTIVO" },
    { id: false, name: "INACTIVO" },
  ];

  const operatorsList = [
    { id: "OPERADOR", name: "OPERARIO POLINIZACION" },
    { id: "SUPERVISOR", name: "SUPERVISOR" },
    { id: "SANIDAD", name: "OPERARIO SANIDAD" },
    { id: "COSECHA", name: "OPERARIO COSECHA" },
    { id: "GENERAL", name: "OPERARIO GENERAL" },
  ];




  const roleListGeneral = [
    { id: "OPERADOR", name: "OPERADOR" },
    { id: "SUPERVISOR", name: "SUPERVISOR" },
    { id: "ADMINISTRADOR", name: "ADMINISTRADOR" },
    { id: "SANIDAD", name: "OPERARIO SANIDAD" },
    { id: "COSECHA", name: "OPERARIO COSECHA" },
    { id: "GENERAL", name: "OPERARIO GENERAL" },
  ];

  const roleListSuperadmin = [
    { id: "OPERADOR", name: "OPERADOR" },
    { id: "SUPERVISOR", name: "SUPERVISOR" },
    { id: "ADMINISTRADOR", name: "ADMINISTRADOR" },
    { id: "SANIDAD", name: "OPERARIO SANIDAD" },
    { id: "COSECHA", name: "OPERARIO COSECHA" },
    { id: "GENERAL", name: "OPERARIO GENERAL" },
    { id: "INTEGRACION", name: "INTEGRACION" },
  ];



  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const searchByName = (e) => {
    const name = e.target.value
    setFindName(name)
  }

  const capitalizeName = (e) => {
    const role = getValues("role");
    console.log(role)
    if (role == "ADMINISTRADOR")
      return;
    let value = e.target.value;
    value = value
      .split(' ') // Divide el texto en palabras
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitaliza la primera letra de cada palabra
      )
      .join(' ');
    setValue("name", value);
  };

  const capitalizeFullName = (e) => {
    const role = getValues("role");
    console.log(role)
    if (role == "ADMINISTRADOR")
      return;
    let value = e.target.value;
    value = value
      .split(' ') // Divide el texto en palabras
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitaliza la primera letra de cada palabra
      )
      .join(' ');
    setValue("fullName", value);
  };

  const toCamelCase = (e) => {
    let value = e.target.value;
    value = value
      .replace(/(?:^\w|[A-Z]|\b\w|\s+|_|\-|\^)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/\s+/g, '')
      .replace(/[^a-zA-Z0-9]/g, '');
    setValue("username", value);
  };

  const toLowerCase = (e) => {
    let value = e.target.value;
    value = value.toLowerCase()
    setValue("username", value);
  };



  const getListUsers = async () => {
    setLoading(true)
    //const initPage = 1
    //setPage(1)
    const response = await userService.getListUsers(page, pageSize, findName);
    if (response)
      setList(response.data);
    setTotal(response.total);
    setLoading(false)
  };

  const updateUser = async () => {
    const id = getValues("id");
    const name = getValues("name");
    const fullName = getValues("fullName");
    const username = getValues("username");
    const identification = getValues("identification");
    const role = getValues("role");
    const profiles = getValues("profiles");
    const password = getValues("passwordForm");
    const state = getValues("state");




    if (usernameSession != "superadmin") {
      if (username != usernameOld) {
        toast.warning("No puede modificar el username (" + username + ")")
        return;
      }
    }


    const data = { name, username, password, id, role, identification, state, profiles, fullName };
    const success = await userService.update(data);
    if (success) {
      reset();
      getListUsers();
      setShowEdit(false);
      setShowSave(true);
      toast('Realizado.', { autoClose: 1000 });
    }
  };

  const customSubmit = async (dataForm) => {

    const id = "";
    const name = getValues("name");
    const fullName = getValues("fullName");
    const username = getValues("username");
    const identification = getValues("identification");
    const role = getValues("role");
    const profiles = getValues("profiles");
    const password = getValues("passwordForm");
    const state = getValues("state");
    const data = { name, username, password, id, role, identification, state, profiles, fullName };
    const response = await userService.insert(data);
    if (response.success) {
      reset();
      getListUsers();
      toast('Realizado.', { autoClose: 1000 });
    }
    else {
      toast.error(response.message);
    }
  };

  const cancelar = async () => {
    setShowEdit(false);
    setShowSave(true);
    reset();
  };

  const getUser = async (userId) => {
    const user = await userService.getUser(userId);
    if (user) {
      setValue("id", user._id);
      setValue("username", user.username);
      setUsernameOld(user.username)
      setValue("name", user.name);
      setValue("fullName", user.fullName);
      if (!user.fullName) {
        setValue("fullName", user.name);
      }
      setValue("identification", user.identification);
      setValue("password", "");
      setValue("state", user.state);
      setValue("role", user.role);
      setValue("profiles", user.profiles || []);
      setShowEdit(true);
      setShowSave(false);


      window.scrollTo({ top: 0, behavior: "smooth" });

    }
  };



  useEffect(() => {
    const usernameLS = localStorage.getItem("username");
    if (usernameLS == "superadmin") {
      setRoleList(roleListSuperadmin)
    }
    else {
      setRoleList(roleListGeneral)
    }

    setUsernameSession(usernameLS)
    setValue("username", "")
    setValue("identification", "")
    setValue("passwordForm", "")
    reset();
  }, []);





  useEffect(() => {
    getListUsers();
  }, [page, pageSize, findName]);




  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 col-sm-4">

        <div className="card p-4">
          <form className="form-react"
            onSubmit={handleSubmit(customSubmit)}

          >
            <div className="row">
              <div className="card-title">
                <h4 className="text-secondary" >Datos del usuario</h4>
              </div>


              <div className=" col-12 d-none">
                <label>Id usuario</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("id")}
                />
              </div>



              <div className="col-12">
                <label>Nombre completo</label>
                <input
                  type="text"
                  onKeyUp={capitalizeFullName}
                  style={{ backgroundColor: "#f5f5eb" }}
                  className="form-control"
                  {...register("fullName", { required: true, minLength: 3 })}
                />
                {errors.fullName?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.fullName?.type === "minLength" && (
                  <small className="text-danger">Mínimo 3 caracteres</small>
                )}
              </div>

              <div className=" col-12 col-sm-6">
                <label>Identificacion</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("identification")}
                />
              </div>



              <div className=" col-12 col-sm-6">
                <label>Usuario -  app</label>
                <input
                  type="text"
                  autoComplete="off"
                  onKeyUp={toLowerCase}
                  className="form-control"
                  {...register("username")}
                />
              </div>



              <div className=" col-12">
                <label>Nombre Informes</label>
                <input
                  type="text"
                  onKeyUp={capitalizeName}
                  className="form-control"
                  {...register("name", { required: true, minLength: 3 })}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.name?.type === "minLength" && (
                  <small className="text-danger">Minimo 10 caracteres</small>
                )}
              </div>



              <div className="col-12">
                <label>Password</label>
                <Controller
                  name="passwordForm"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Input.Password
                      {...field}
                      autoComplete="new-password" // Aquí va el atributo correcto
                      placeholder="Campo password"
                    />
                  )}
                />
                {errors.passwordForm?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
              </div>


              <div className=" col-12">
                <label>Rol</label>
                <select className="form-control" {...register("role")}>
                  {roleList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className={showProfiles ? "col-12" : "d-none"}>
                <label>Perfiles</label>

                <div className="border rounded p-3">

                  {operatorsList.map((option) => (
                    <div className="form-check mb-2" key={option.id}>

                      <input
                        className="form-check-input"
                        type="checkbox"
                        value={option.id}
                        {...register("profiles")}
                        id={`profile-${option.id}`}
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`profile-${option.id}`}
                      >
                        {option.name}
                      </label>

                    </div>
                  ))}

                </div>

                {errors.profiles && (
                  <small className="text-danger">
                    Debe seleccionar al menos un perfil
                  </small>
                )}
              </div>


              <div className=" col-12">
                <label>Estado</label>
                <select className="form-control" {...register("state")}>
                  {optionsState.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className={showEdit ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <button
                  className="btn btn-success w-100"
                  type="button"
                  onClick={() => updateUser()}
                >
                  <i class="fa-regular fa-pen-to-square fa-lg" /> Editar
                </button>
              </div>

              <div className={showSave ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <button className="btn btn-primary w-100" type="submit">
                  <i className="fa-regular fa-floppy-disk fa-lg m-2" /> Guardar
                </button>
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <button
                  className="btn btn-secondary w-100"
                  type="button"
                  onClick={() => cancelar()}
                ><i class="fa-solid fa-square-xmark  fa-lg m-2"></i>  Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>


      <div className="col-12 col-sm-8">
        <div className="card p-4">
          <div className="row">


            <div className="col-4">
              <Input
                prefix={<SearchOutlined className="text-primary" />}
                placeholder={"Nombre"}
                onChange={e => searchByName(e)}
              />
            </div>


            <div className="col-8">
              <Pagination
                className="text-primary "
                current={page}
                pageSize={pageSize}
                total={total}
                onChange={handlePageChange}
                pageSizeOptions={["5", "10", "20", "50"]}
                showTotal={(total) => `Total ${total} usuarios`}
                showSizeChanger
                onShowSizeChange={(current, size) => handlePageChange(1, size)}
              />
            </div>

            <div className="col-12 mt-3">

              <Spin spinning={loading}>
                <div className="bdr">
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="table-primary">
                        <tr>
                          <th>Nombre</th>
                          <th>Username</th>
                          <th>Identificación</th>
                          <th>Rol</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((user, index) => {

                          if (usernameSession != "superadmin") {
                            if (user.username == "superadmin" || user.role == "INTEGRACION") return "";
                          }




                          return (
                            <tr key={index} className={user.state ? "" : "table-secondary"}  >
                              <td>{user.name}</td>
                              <td>{user.username}</td>
                              <td>{user.identification}</td>
                              <td>{user.role}</td>
                              <td style={{ width: "100px" }}>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => getUser(user._id)}
                                >
                                  <i className="bi bi-pencil-square fa-lg m-1" /> Editar
                                </button>

                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Spin>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default AdminUsers;
